<template>
  <article class="map-content">
    <v-btn class="map-content__close-button" dark icon @click="onClose">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-btn v-if="isShowSetButton" class="map-content__set-button" @click="onSubmit">설정하기</v-btn>
    <naver-maps
      :height="800"
      :width="1000"
      :mapOptions="mapOptions"
      :initLayers="['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT']"
      @load="onLoad"
      class="map__content"
    >
    </naver-maps>
  </article>
</template>

<script>
export default {
  name: 'MapRange',
  props: {
    pathData: {
      type: Array,
      default: () => []
    },
    isShowSetButton: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      mapOptions: {
        lat: 37.4788755,
        lng: 127.1271389,
        zoom: 17,
        zoomControl: true,
        zoomControlOptions: { position: 'TOP_RIGHT' },
        mapTypeControl: true
      },
      path: this.pathData
    }
  },
  methods: {
    onLoad (vue) {
      const marker = []

      // 시작 포지션
      if (this.pathData && this.pathData[0]) {
        const point = new window.naver.maps.LatLng(this.pathData[0].lat, this.pathData[0].lng)
        vue.map.setCenter(point)
      }

      // 시작 path
      const path = this.pathData.map(x => {
        return new window.naver.maps.LatLng(x.lat, x.lng)
      }, [])

      // 시작 마커
      path.forEach(point => {
        marker.push(new window.naver.maps.Marker({
          map: vue.map,
          position: point
        }))
      })

      // 폴리라인 초기화
      const polygon = new window.naver.maps.Polygon({
        map: vue.map,
        paths: [path],
        fillColor: '#ff0000',
        fillOpacity: 0.3,
        strokeColor: '#ff0000',
        strokeOpacity: 0.6,
        strokeWeight: 3,
        clickable: true
      })

      // 맵 클릭시 폴리라인 찍기
      window.naver.maps.Event.addListener(vue.map, 'click', (e) => {
        const point = e.coord
        const path = polygon.getPaths().getAt(0)
        path.push(point)
        this.path.push({
          lat: point._lat,
          lng: point._lng
        })
        marker.push(new window.naver.maps.Marker({
          map: vue.map,
          position: point
        }))
      })

      // 실행취소 버튼
      const locationBtnHtml = '<button class="map__back-button">선택 되돌리기</button>'
      window.naver.maps.Event.once(vue.map, 'init_stylemap', () => {
        const customControl = new window.naver.maps.CustomControl(locationBtnHtml, {
          position: window.naver.maps.Position.TOP_RIGHT
        })
        customControl.setMap(vue.map)
        window.naver.maps.Event.addDOMListener(customControl.getElement(), 'click', () => {
          const path = polygon.getPaths().getAt(0)
          path.splice(path.length - 1, 1)
          this.path.splice(path.length - 1, 1)
          marker[marker.length - 1].setMap(null)
          marker.splice(marker.length - 1, 1)
        })
      })
    },
    onClose () {
      this.$emit('closeModal')
    },
    onSubmit () {
      this.$emit('onSubmitMapRange', this.path)
    }
  }
}
</script>

<style lang="scss">
  .map-content {
    width: 100%;
    height: 100%;
    &__close-button {
      position: absolute;
      right: 7px;
      top: 14px;
      color: #fff;
    }
    &__set-button {
      position: absolute;
      top: 14px;
      right: 80px;
    }
  }
  .map__content {
    margin: 0 auto;
  }
  .map__back-button {
    background: #ec1816;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
    //position: absolute;
    margin-top: 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,.4);
    font-size: 14px;
  }
</style>
